import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { alpha } from '@mui/material/styles';
import { shouldForwardProp } from '@mui/system';
import { styled } from "../internals/zero-styled/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
const TreeItem2DragAndDropOverlayRoot = styled('div', {
  name: 'MuiTreeItem2DragAndDropOverlay',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => shouldForwardProp(prop) && prop !== 'action'
})(({
  theme
}) => ({
  position: 'absolute',
  left: 0,
  display: 'flex',
  top: 0,
  bottom: 0,
  right: 0,
  pointerEvents: 'none',
  variants: [{
    props: {
      action: 'make-child'
    },
    style: {
      marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha((theme.vars || theme).palette.primary.dark, 0.15)
    }
  }, {
    props: {
      action: 'reorder-above'
    },
    style: _extends({
      marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
      borderTop: `1px solid ${alpha((theme.vars || theme).palette.grey[900], 0.6)}`
    }, theme.applyStyles('dark', {
      borderTopColor: alpha((theme.vars || theme).palette.grey[100], 0.6)
    }))
  }, {
    props: {
      action: 'reorder-below'
    },
    style: _extends({
      marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
      borderBottom: `1px solid ${alpha((theme.vars || theme).palette.grey[900], 0.6)}`
    }, theme.applyStyles('dark', {
      borderBottomColor: alpha((theme.vars || theme).palette.grey[100], 0.6)
    }))
  }, {
    props: {
      action: 'move-to-parent'
    },
    style: _extends({
      marginLeft: 'calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))',
      borderBottom: `1px solid ${alpha((theme.vars || theme).palette.grey[900], 0.6)}`
    }, theme.applyStyles('dark', {
      borderBottomColor: alpha((theme.vars || theme).palette.grey[900], 0.6)
    }))
  }]
}));
function TreeItem2DragAndDropOverlay(props) {
  if (props.action == null) {
    return null;
  }
  return /*#__PURE__*/_jsx(TreeItem2DragAndDropOverlayRoot, _extends({}, props));
}
export { TreeItem2DragAndDropOverlay };